"use client";

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import type { ProductDetail } from "@/lib/types/product";
import { useAuthStore } from "@/stores/authStore";

export function useProduct(id: number | null) {
  const token = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: ["product", id],
    queryFn: async () => {
      const { data } = await api.get<{ product: ProductDetail }>(
        `/api/products/${id}`,
      );

      return data.product;
    },
    enabled: Boolean(token) && id != null && id > 0,
  });
}
